// @ts-ignore
/* eslint-disable */
import type { CustomRequestOptions } from '../customRequestOptions';
import { request } from '../axios/mchTradeData';

/** 查询当天交易日期门店的交易排名topN POST /pc/b/company/index/dashboard/statement/shop/today/rank/topN */
export async function shopTodayRankTopN(
  body: APIMchTradeData.QryCompanyTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.ListResponseBpCompanyShopTopDto_>(
    '/pc/b/company/index/dashboard/statement/shop/today/rank/topN',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询当天交易日期最近N天的数据(近N日交易) POST /pc/b/company/index/dashboard/statement/trade/today/nearest */
export async function todayNearest(
  body: APIMchTradeData.QryCompanyTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.ListResponseBpIndexBusinessTrendStatDataDto_>(
    '/pc/b/company/index/dashboard/statement/trade/today/nearest',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询当天交易数据概览(今日数据概览) POST /pc/b/company/index/dashboard/statement/trade/today/overview */
export async function todayOverview(
  body: APIMchTradeData.QryCompanyTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.CommonResponseBpIndexStatOverviewDto_>(
    '/pc/b/company/index/dashboard/statement/trade/today/overview',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}

/** 查询当天交易日期商户的交易排名topN POST /pc/b/company/index/dashboard/statement/trade/today/rank/topN */
export async function rankTopN(
  body: APIMchTradeData.QryCompanyTradeTodayStatRequest,
  options?: CustomRequestOptions,
) {
  return request<APIMchTradeData.CommonResponseBpCompanyRankDto_>(
    '/pc/b/company/index/dashboard/statement/trade/today/rank/topN',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data: body,
      ...(options || {}),
    },
  );
}
